import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-main-container',
  templateUrl: './main-container.component.html',
  styleUrls: ['./main-container.component.scss']
})
export class MainContainerComponent implements OnInit {
  constructor(private router: Router) {
  }
  isSidebarVisible: boolean = false;
  ngOnInit(): void {

  }
  toggleSidebar() {
    this.isSidebarVisible = !this.isSidebarVisible;
  }
  collapse(){
    this.isSidebarVisible = false;
  }
}
